// @mui
import { CssBaseline } from '@mui/material';
import {
  ThemeProvider as MUIThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import { useMemo } from 'react';
import type { ThemeModeValue } from 'src/components/settings/types';
// components
import { useThemeSettingsContext } from '../components/settings/ThemeSettingsContext';
//
import GlobalStyles from './globalStyles';
import { createThemeConfig } from './themeConfig';

type Props = {
  children: React.ReactNode;
  themeMode?: ThemeModeValue;
};

export default function ThemeProvider({
  children,
  themeMode: propThemeMode,
}: Props) {
  const { themeMode: contextThemeMode } = useThemeSettingsContext();
  const mode = propThemeMode || contextThemeMode;

  const theme = useMemo(() => createThemeConfig(mode), [mode]);
  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
